/* eslint-disable */
export default {
  'ru-RU': {
    common: {
      NAME_HOLDER: "Имя *",
      LAST_NAME_HOLDER: "Фамилия *",
      EMAIL_HOLDER: "Адрес электронной почты *",
      PASS_HOLDER: "Придумайте пароль *",
      REPEAT_PASS_HOLDER: "Подтвердите пароль *",
      BUTTON_EMAIL_SIGN_UP: "Регистрация с помощью электронной почты",

      TERMS_AND_CONDITIONS: "условия использования",
      PRIVACY_POLICY: "Политика Приватности",

      NEWSLETTER_CONSENT: "Я соглашаюсь получать уведомления от Time Out о последних новостях, событиях, предложениях и партнерских акциях",
      TERM_OF_USE: "Я ознакомлен и согласен с Пользовательским Соглашением и Политикой Приватности Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "Я принимаю {{terms_and_conditions}} Time Out и даю согласие на получение новостной рассылки.",

      HEADER_TITLE: "Создать аккаунт в Time Out",
      JOIN_FB: "Зарегистрироваться с помощью Facebook",
      JOIN_TW: "Зарегистрироваться с помощью Twitter",
      JOIN_GG: "Зарегистрироваться с помощью Google",
      JOIN_EM: "Зарегистрироваться с помощью электронной почты",
      ALREADY_HAVE: "Уже есть аккаунт в Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Авторизоваться",

      SIGN_IN_TITLE: "Войти в систему",
      SIGN_IN_FB: "Войти через Facebook",
      SIGN_IN_TW: "Войти через Twitter",
      SIGN_IN_GG: "Войти через Google",
      SIGN_IN_EM: "Войти через электронную почту",
      YOUR_EMAIL: "Адрес вашей электронной почты",
      YOUR_PASSWORD: "Ваш пароль",
      REMEMBER: "Запомните меня",
      FORGOT: "Забыли?",
      HAVE_ACCOUNT_YET: "У вас еще нет аккаунта Time Out?",
      JOIN_HERE: "Присоединиться",
      ALMOST_THERE: "почти готово",

      FORGOT_HEADER: "Забыли пароль?",
      FORGOT_SUBTITLE: "Это не проблема. Введите ниже адрес вашей почты и мы пришлем вам ссылку для переустановки пароля.",
      SEND_LINK: "Отправить ссылку",

      RECEIVE_EMAIL: "Спасибо! В ближайшее время вы получите письмо. ",
      MANAGE_ACCOUNT: "Настроить аккаунт",
      EDIT_DETAILS_HERE: "Редактировать аккаунт можно тут",
      FIRST_NAME: "Имя",
      LAST_NAME: "Фамилия",
      SCREEN_NAME: "Ваш никнейм",
      EMAIL: "Адрес электронной почты",
      ACCOUNT_DETAILS: "Настройки аккаунта",
      PASSWORD: "Пароль",
      SAVE_CHANGES: "Сохранить изменения",
      UPLOAD_PIC: "Загрузить новую фотографию профиля",
      CHOOSE_PHOTO: "Выберите фотографию с вашего устройства. Максимальный размер файла 2 MB.",
      CLOSE_ACCOUNT: "Закрыть учетную запись",
      PASSWORD_BELOW: "Изменить пароль можно ниже",
      CURRENT_PASSWORD: "Текущий пароль",
      NEW_PASSWORD: "Новый пароль",
      REPEAT_PASSWORD: "Подтвердите новый пароль",

      OOPS: "Упс!",
      ERROR_404_OCCURED: "Произошла ошибка",
      ERROR_404_INFO: "Страницы больше не существует или она была перемещена",
      ERROR_500_TITLE: "Сервер вернул ",
      SMTH_BROKEN: "Возникли неполадки",
      INTERNAL_RED: "500 Внутренняя ошибка сервера",
      LET_KNOW_RED: "Пожалуйста, опишите ваши действия, при которых возникла ошибка. Мы решим проблему в ближайшее время. Приносим извинения за причиненные неудобства.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Пожалуйста, введите действующий адрес электронной почты.",
      PASSWORD_ERROR: "Пожалуйста, введите пароль.",
      FIRST_NAME_ERROR: "Пожалуйста, введите Ваше имя",
      LAST_NAME_ERROR: "Введите свою фамилию",
      TERM_OF_USE_ERROR: "Вы должны согласиться с нашими условиями использования",
      SIGN_IN_VALIDATION_ERROR: "Неверный адрес почты или пароль. Пожалуйста, попробуйте снова.",
      ACCOUNT_PASSWORDS_VALIDATION: "Пароли не совпадают",
      WAS_IT: "Мы что-то сделали не так?",
      DELETE_ACCOUNT_TEXT: "Нам очень жаль, что вы хотите удалить учетную запись. Если что-то заставило вас принять такое решение",
      DELETE_ACCOUNT: "Удалить аккаунт",
      CANCEL: "Отменить",

      UPDATE_PASSWORD: "Обновить пароль",
      PASSWORD_UPDATE_SUCCESS: "Ваш пароль был обновлен",
      ERROR_PASSWORD_LENGTH: "Пароль должен содержать не менее 6 символов",

      ERROR_MISSING_SITE_PARAMETER: "Отсутствует обязательный параметр приложения: site",
      ERROR_ALREADY_REGISTERED: "Вы уже зарегистрированы, используя электронную почту. Пожалуйста, войдите, используя {{email}}",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/ru-RU.js